export const USER_TYPE = {
  0: "General User",
  1: "API User",
};

export type TUserType = keyof typeof USER_TYPE;
